import React from 'react';
import Image from 'next/image';
import campusdrivebg from "../../public/images/campusdrivebg.jpg";
import Link from 'next/link';

const Drivesolution = () => {
  return (
    <>
      <div className='relative'>
        <Image src={campusdrivebg} alt='campus hiring platform' className='lg:h-[250px] h-[180px] w-full' />
        <div className='2xl:mx-24 xl:mx-20 lg:mx-20 md:mx-20 sm:mx-10 mx-5 absolute inset-0 flex flex-col justify-center items-center'>
          <div className='grid grid-cols-1 lg:grid-cols-12'>
            <div className='col-span-1 lg:col-span-8 lg:text-right text-center'>
              <p className='lg:text-4xl text-[white]'>Ease your process with our one stop,</p>
              <h2 className='lg:text-[65px] text-[20px] text-white font-extrabold tracking-wide'> Campus Drive Solution</h2>
            </div>
            <div className='col-span-1 lg:col-span-4 flex items-center justify-center lg:ml-20'>
              <Link target='_balnk' href="https://app.easycampus.in/registration">
                <button className='campusdrivebtn aboutbtn-1 font-bold' >Click here</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Drivesolution